// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"01d59a8a","567":"724ca8e7","946":"65568695"}[chunkId] + ".chunk.js";
};